export default "__VITE_ASSET__DapMN$Ti__"